<template lang="pug">
div
  sticky(className="sub-navbar")
    template(v-if='getPageType() !== "create"')
      el-button(type='success' size='mini' icon='el-icon-tickets' @click='onSaveSendGrid') SendGridに登録
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave') 保存
    template(v-if='getPageType() !== "create"')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit' @click="preview('ja')") プレビュー
    el-button(v-if='getPageType() !== "create"' size='mini' type='danger' icon='el-icon-delete' @click='onDelete') 削除
    .options__func
      el-button(type='success' size='mini' icon='el-icon-sort' @click='showModal("sortelement")' :disabled='hasAddItems') 順序変更
      el-button(type='primary' size='mini' icon='el-icon-plus' @click='showModal("addelement")') 要素追加
  .contents-container
    el-form.c-form(ref='form', :model='form', :rules='rules', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 タイトル
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.title.ja' placeholder='タイトルを入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.title.en' placeholder='タイトルを入力してください')

        section.c-form__item
          header.c-form__item__header
            h1 NO
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(prop="no")
                  el-input(v-model='form.no' placeholder='NOを入力してください')
                  p.caption 番号を入力してくださいURLおよびニュースレータ発行番号に使われます

        section.c-form__item
          header.c-form__item__header
            h1 ステータス
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-select(v-model='form.status')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')

        section.c-form__item
          header.c-form__item__header
            h1 日時
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-date-picker(v-model='form.date', value-format='yyyy-MM-dd', type='date', placeholder='年月日を設定してください')

        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description.ja' placeholder='一覧ページに表示する説明文を入力してください' type='textarea' :rows='5')
                  p.caption NEWS一覧ページに表示する説明文を入力してください。(200文字程度まで)
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description.en' placeholder='一覧ページに表示する説明文を入力してください' type='textarea' :rows='5')
        section.c-form__item
          header.c-form__item__header
            h1 メイン画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-single(:form='form' datakey='main_image' ratio='3_2')
      header.c-form__header.c-form__header--opt
        h1 オプショナル項目
      .c-form__body
        section.c-form__item(v-for='(element, index) in form.additional_items' :key='index')
          template(v-if='element.item_type === "video"')
            header.c-form__item__header
              h1 単数動画
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20')
                el-col(:span='12')
                  el-form-item
                    el-input(v-model='form.additional_items[index].video_uri' placeholder='動画サイトのURLを入力してください')
                    p.caption サムネイルは動画サイトに設定したものが使用されます。
          template(v-else-if='element.item_type === "image"')
            header.c-form__item__header
              h1 単数画像
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20')
                el-col(:span='12')
                  el-form-item
                    upload-single(:form='form' :datakey='"additional_items." + index' type='nested' ratio='960_531')
          template(v-else-if='element.item_type === "images"')
            header.c-form__item__header
              h1 複数画像
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              upload-multi(:form='form' :datakey='"additional_items." + index' ratio='960_531')
          template(v-else-if='element.item_type === "titleAndText"')
            header.c-form__item__header
              h1 タイトル&テキスト
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20')
                el-col(:span='12')
                  el-form-item(label='日本語')
                    el-input(v-model='form.additional_items[index].title.ja' placeholder='タイトルを入力してください')
                    el-input(v-model='form.additional_items[index].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='20')
                el-col(:span='12')
                  el-form-item(label='英語')
                    el-input(v-model='form.additional_items[index].title.en' placeholder='タイトルを入力してください')
                    el-input(v-model='form.additional_items[index].body.en' placeholder='テキストを入力してください' type='textarea' :rows='20')
          template(v-else-if='element.item_type === "text"')
            header.c-form__item__header
              h1 テキスト
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20')
                el-col(:span='12')
                  el-form-item(label='日本語')
                    el-input(v-model='form.additional_items[index].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='20')
                el-col(:span='12')
                  el-form-item(label='英語')
                    el-input(v-model='form.additional_items[index].body.en' placeholder='テキストを入力してください' type='textarea' :rows='20')
              div
                p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;

          template(v-else-if='element.item_type === "headlineTitle"')
            header.c-form__item__header
              h1 ヘッドラインタイトル
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20')
                el-col(:span='12')
                  el-form-item(label='日本語')
                    el-input(v-model='form.additional_items[index].title.ja' placeholder='タイトルを入力してください')
                el-col(:span='12')
                  el-form-item(label='英語')
                    el-input(v-model='form.additional_items[index].title.en' placeholder='タイトルを入力してください')
          template(v-else-if='element.item_type === "multiTitleAndText"')
            header.c-form__item__header
              h1 2カラム タイトル&テキスト （リニューアル後は対応する要素がないため1カラムで表示されます。）
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              el-row(:gutter='20' v-for='(e, i) in form.additional_items[index].texts' :key='i')
                el-col(:span='12')
                  el-form-item(label='日本語')
                    el-input(v-model='form.additional_items[index].texts[i].title.ja' placeholder='タイトルを入力してください')
                    el-input(v-model='form.additional_items[index].texts[i].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='20')
                el-col(:span='12')
                  el-form-item(label='英語')
                    el-input(v-model='form.additional_items[index].texts[i].title.en' placeholder='タイトルを入力してください')
                    el-input(v-model='form.additional_items[index].texts[i].body.en' placeholder='テキストを入力してください' type='textarea' :rows='20')
          template(v-else-if='element.item_type === "imagesV"')
            header.c-form__item__header
              h1 複数画像[縦長]
              i.icon.el-icon-delete(@click='deleteItem(index)')
            .c-form__item__body
              upload-multi(:form='form' :datakey='"additional_items." + index' type='thumb' ratio='v')
  template(v-if='!LOADING')
    modal-add-element(:visible='modal.addelement.visible' @hideModal='hideModal' type='newsletter')
    modal-sort-element(:visible='modal.sortelement.visible' @hideModal='hideModal' :list='form.additional_items')
</template>

<script type='text/javascript'>
import form from '@/mixins/form'
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import UploadMulti from '@/components/Element/Upload/Multi'
import ModalAddElement from '@/components/Element/Modal/AddElement'
import ModalSortElement from '@/components/Element/Modal/SortElement'
import * as apiNewsletter from '@/api/newsletter'
import * as types from '@/store/mutation-types/'
export default {
  name: 'PagesNewsletterDetail',
  mixins: [form],
  data () {
    return {
      modal: {
        addelement: {
          visible: false
        },
        sortelement: {
          visible: false
        }
      },
      rules: {
        no: [{ required: true, message: 'NOは必須です', trigger: 'blur' }]
      },
      initialForm: null, // 初期値
      form: {
        id: null,
        textcolor: null,
        no: null,
        date: null,
        status: 0,
        title: {
          ja: null,
          en: null
        },
        description: {
          ja: null,
          en: null
        },
        main_image: {
          id: null,
          uri: null
        },
        thumbnail: {
          square: null,
          rectangle: null
        },
        additional_items: []
      }
    }
  },
  methods: {
    /**
     * @param {String} key
     */
    showModal (key) {
      this.modal[key].visible = true
    },
    /**
     * @param {String} key
     * @param {Object} data
     */
    hideModal (key, data) {
      this.modal[key].visible = false
      if (key === 'addelement' && data) {
        this.form.additional_items.push(data)
      }
    },
    onSaveSendGrid () {
      this.$confirm('保存済みの情報をSendGridに登録します、編集中の情報がある場合は保存後に登録してください。', 'Warning', {
        confirmButtonText: '登録する',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.$store.commit(types.LOADER, true)
        apiNewsletter.postSendgrid(this.form.id)
          .then(() => {
            this.$message({
              type: 'success',
              message: 'SendGridへの登録に成功しました'
            })
            this.$store.commit(types.LOADER, false)
          }).catch(() => {
            this.$store.commit(types.LOADER, false)
            this.$message.error('SendGridへの登録に失敗しました')
          })
      }).catch(() => {
      })
    },
    hasUnsavedChanges () {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    },
    validation () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onSave()
        } else {
          this.$message.error('入力内容に誤りがあります。')
          return false
        }
      })
    },
    preview (lang) {
      const openPreviewWindow = (lang) => {
        const path = lang === 'ja' ? '' : 'en/'
        const currentHost = location.hostname

        let previewBaseUrl

        if (currentHost === 'w0w-2024-cms.s2factory.co.jp') {
          previewBaseUrl = 'https://w0w-2024-www.s2factory.co.jp'
        } else if (currentHost === 'cms.w0w.co.jp') {
          previewBaseUrl = 'https://www.w0w.co.jp'
        } else {
          // デフォルト（予期しないホストの場合）
          previewBaseUrl = 'https://www.w0w.co.jp'
        }

        const url = `${previewBaseUrl}/${path}draft/news/${this.form.no}`
        window.open(url, '_blank')
      }
      if (this.hasUnsavedChanges()) {
        this.$confirm('未保存の変更があります。保存せずにプレビューしますか？', '確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          openPreviewWindow(lang)
        }).catch(() => {
        // キャンセルされた場合は何もしない
        })
      } else {
        openPreviewWindow(lang)
      }
    }
  },
  computed: {
    /**
     * @return {Boolean}
     */
    hasAddItems () {
      return !(this.form.additional_items.length > 0)
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    UploadSingle,
    UploadMulti,
    ModalAddElement,
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Newsletter/Detail/index.vue